import React from 'react';
import { connect } from 'react-redux';
import { Checkbox } from 'semantic-ui-react';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import { makeSelectOnlyMyTimesheetsCheckboxValue } from 'services/onlyMyTimesheetsCheckbox/selectors';
import { onlyMyTimesheetsCheckboxToggle } from 'services/onlyMyTimesheetsCheckbox/actions';
import { OnlyMyTimesheetsCheckboxState } from 'services/onlyMyTimesheetsCheckbox/types';

interface DispatchProps {
    toggleCheckbox: Function;
}

export class OnlyMyTimesheetCheckbox extends React.PureComponent<
    OnlyMyTimesheetsCheckboxState & DispatchProps
> {
    handleOnChange = (): void => {
        const { toggleCheckbox } = this.props;

        toggleCheckbox();
    };

    render(): React.ReactElement {
        const { checked } = this.props;

        return (
            <Checkbox
                onChange={this.handleOnChange}
                checked={checked}
                label="Only me"
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    {},
    OnlyMyTimesheetsCheckboxState
>({
    checked: makeSelectOnlyMyTimesheetsCheckboxValue('checked')
});

const mapDispatchToProps = {
    toggleCheckbox: onlyMyTimesheetsCheckboxToggle
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OnlyMyTimesheetCheckbox);
